import { getImageURL } from '../../../../utils/GeneralUtil';
export var SQUARE_BENEFITS_CONSTANTS = {
    TITLE: function (amt) { return "Square ".concat(amt, " Discount"); },
    SUBTITLE: "Save on Processing Fees",
    HEADLINE: function (amt) { return "Square Savings: ".concat(amt); },
    MESSAGE: {
        ELITE: {
            LOCKED: "Unlock the Elite tier and get a $3,000 processing credit \n      toward transactions made with Square.",
            UNLOCKED: "You have unlocked an annual processing credit toward transactions \n      made with Square. If you haven't already, connect your Pro Xtra account with \n      Square using the unique link we sent via email and start saving.",
        },
        VIP: {
            LOCKED: "Save even more when you unlock the VIP tier \u2013 get a $5,000 \n      processing credit toward transactions made with Square.",
            UNLOCKED: "You have unlocked an annual processing credit toward transactions \n      made with Square. If you haven't already, connect your Pro Xtra account with \n      Square using the unique link we sent via email and start saving.",
        },
        '': { LOCKED: '', UNLOCKED: '' },
    },
    FOOTER: {
        HEADLINE: "Need help connecting your account?",
        MESSAGE: {
            MW: "Customer Solutions",
            DTW: "Call Customer Solutions at ",
        },
        PHONE_TAG: "eliteCallCenter",
    },
    ICON_URL: getImageURL("icon-SquareBenefits.svg"),
    TIER_URL: getImageURL('logo-Pro-Xtra-grey.svg'),
};
